var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11782 37.931H41.4511C42.597 37.931 43.5345 36.9935 43.5345 35.8477C43.5345 34.7019 42.597 33.7644 41.4511 33.7644H8.11782C6.97198 33.7644 6.03448 34.7019 6.03448 35.8477C6.03448 36.9935 6.97198 37.931 8.11782 37.931ZM8.11782 27.5144H41.4511C42.597 27.5144 43.5345 26.5769 43.5345 25.431C43.5345 24.2852 42.597 23.3477 41.4511 23.3477H8.11782C6.97198 23.3477 6.03448 24.2852 6.03448 25.431C6.03448 26.5769 6.97198 27.5144 8.11782 27.5144ZM6.03448 15.0144C6.03448 16.1602 6.97198 17.0977 8.11782 17.0977H41.4511C42.597 17.0977 43.5345 16.1602 43.5345 15.0144C43.5345 13.8685 42.597 12.931 41.4511 12.931H8.11782C6.97198 12.931 6.03448 13.8685 6.03448 15.0144Z",
    fill: "#030303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.c018f602968f34534b42b04429fca7ad.svg";
export { ForwardRef as ReactComponent };